import type { paths } from "@/api-schema";
import { useUserByUuidQuery } from "@/common/api/user/use-user-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { UpdateGuestFormFields } from "./_components/update-guest-form-fields";

interface UpdateViewParams {
  uuid: string;
}

export function UpdateGuestView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<UpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/user/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/user/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useUserByUuidQuery}
      notFoundProps={{
        title: t("masterdata:NotFound"),
        message: t("masterdata:UserDoesNotExist"),
        description: t("masterdata:CheckUserIdOrContactSupport"),
        backTo: "~/masterdata/user",
        backToLabel: t("masterdata:BackToUserOverview"),
      }}
    >
      <UpdateGuestViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function UpdateGuestViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:EditGuest");
  const pageSubtitle = t("common:ReviewAndSaveChangesDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <UpdateGuestFormFields uuid={uuid} />
    </CenteredLayout>
  );
}
